/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

// import Toast from 'react-native-toast-message';
import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import MoreButton from '@components/navbar/MoreButton';

import UsersScreen from '@/screens/setting/users/UsersScreen';
import UserFormScreen from '@/screens/setting/users/UserFormScreen';
import UserDetailScreen from '@/screens/setting/users/UserDetailScreen';

// import { MsAccount } from '@api/ms-account';

const Stack = createStackNavigator();

const UserNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  // const goToProfileForm = (params = {}) => {
  //   navigation.navigate('UserFormScreen', params);
  // };

  return (
    <Stack.Navigator
      initialRouteName="UsersScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      {!hasNoAccess([
        'superadmin',
        'sales_admin',
        'sales_supervisor',
        'branch_head',
        'regional_manager',
        'regional_support',
        'key_account_manager',
        'group_key_account_manager',
        'national_key_account_manager',
        'distributor_manager',
        'general_manager',
        'vice_president',
        'marketing_admin',
        'chief_of_staff',
        'regional_distributor_manager',
      ]) ? (
        <Stack.Screen
          name="UsersScreen"
          component={UsersScreen}
          options={(props) => ({
            title: setTitleHeader('Users'),
            headerRight: () => {
              const showFilter = () =>
                dispatch(showPopup({ name: 'showFilter', value: 'users' }));
              const showOptions = () =>
                dispatch(showPopup({ name: 'userCreateOption', value: true }));
              const hasAccess = !hasNoAccess(['superadmin']);
              const menus = [
                { type: 'function', name: 'Filter', callback: showFilter },
              ];
              if (hasAccess) {
                menus.unshift({
                  type: 'function',
                  name: 'Add',
                  callback: showOptions,
                });
              }
              return isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton menu={menus} {...props} />
              );
            },
          })}
        />
      ) : (
        navigation.navigate('HomeNavigator')
      )}
      {!hasNoAccess([
        'superadmin',
        'sales_admin',
        'marketing_admin',
        'chief_of_staff',
      ]) ? (
        <Stack.Screen
          name="UserFormScreen"
          component={UserFormScreen}
          options={(props) => {
            const route = props.route;
            let title = 'Add User';
            let isEdit = false;
            if (route.params && route.params.id) {
              title = 'Edit User';
              isEdit = true;
            }
            return {
              title: setTitleHeader(title),
              headerLeft: () => (
                <BackButton
                  {...props}
                  customBack={{
                    screen: isEdit ? 'ProfileNavigator' : 'UsersScreen',
                    params: isEdit
                      ? route.params
                      : { id: '', name: '', titleScreen: '' },
                  }}
                  isJump
                />
              ),
              headerRight: () =>
                isWeb ? <NotificationSettingButton {...props} /> : false,
            };
          }}
        />
      ) : (
        navigation.navigate('HomeNavigator')
      )}
      {!hasNoAccess([
        'superadmin',
        'sales_admin',
        'sales_supervisor',
        'branch_head',
        'regional_manager',
        'regional_support',
        'key_account_manager',
        'group_key_account_manager',
        'national_key_account_manager',
        'distributor_manager',
        'general_manager',
        'vice_president',
        'marketing_admin',
        'chief_of_staff',
        'regional_distributor_manager',
      ]) ? (
        <Stack.Screen
          name="UserDetailScreen"
          component={UserDetailScreen}
          options={(props) => {
            const route = props.route;
            const title = route.params?.titleScreen || '';

            return {
              title: setTitleHeader(title),
              headerLeft: () => <BackButton {...props} />,
              // headerRight: () => {
              //   const onInvite = async () => {
              //     if (route && route.params && route.params.id) {
              //       dispatch(showPopup({ name: 'isLoading', value: true }));
              //       const inviteUser = await MsAccount.inviteUser(
              //         route.params.id,
              //       );
              //       if (inviteUser && inviteUser.data && inviteUser.data.data) {
              //         dispatch(showPopup({ name: 'isLoading', value: false }));
              //         Toast.show({
              //           text1: 'Berhasil meng-invite user',
              //           type: 'success',
              //         });
              //       } else {
              //         dispatch(showPopup({ name: 'isLoading', value: false }));
              //         Toast.show({
              //           text1: 'Gagal meng-invite user',
              //           type: 'error',
              //         });
              //       }
              //     } else {
              //       Toast.show({
              //         text1: 'A system error occurred',
              //         type: 'error',
              //       });
              //     }
              //   };
              //   return isWeb ? (
              //     <NotificationSettingButton {...props} />
              //   ) : (
              //     <MoreButton
              //       menu={[
              //         {
              //           type: 'function',
              //           name: 'Edit',
              //           callback: () => goToProfileForm(route.params),
              //         },
              //         {
              //           type: 'function',
              //           name: 'Invite User',
              //           callback: onInvite,
              //         },
              //       ]}
              //       {...props}
              //     />
              //   );
              // },
            };
          }}
        />
      ) : (
        navigation.navigate('HomeNavigator')
      )}
    </Stack.Navigator>
  );
};

export default UserNavigator;
